import { twMerge } from 'tailwind-merge';
import { formatUserName } from '@witmetrics/utils/strings';
import { useLead } from '@witmetrics/data-store';
import IconButton from '@/components/IconButton';
import { CloseIcon } from '@/icons';
import { classes } from './utils';

export type LeadListItemProps = {
  active?: boolean;
  leadId: number;
  onSelect: () => void;
};

export default function LeadListItem({
  active,
  leadId,
  onSelect,
}: LeadListItemProps) {
  const lead = useLead(leadId);
  if (!lead) return null;

  return (
    <li
      key={leadId}
      className={twMerge(
        classes.listItem,
        active ? classes.active : classes.inactive
      )}
      onClick={active ? undefined : onSelect}>
      {formatUserName(lead)}
      {active && (
        <IconButton onClick={onSelect}>
          <CloseIcon className={classes.icon} />
        </IconButton>
      )}
    </li>
  );
}
